import { trpc } from '../trpc'

export const subscriptionHooks = {
  useGetById: (id?: number) => {
    return trpc.subscription.getById.useQuery({ id: id! }, { enabled: !!id })
  },
  useServiceStatusByProperty: (propertyId?: number) => {
    return trpc.subscription.getServiceStatusByProperty.useQuery(
      { propertyId: propertyId! },
      { enabled: !!propertyId },
    )
  },
}
